/**
 * Gets the nodes in the returned page
 *
 * @param   {array}     edges     the edges to iterate to
 * @returns {Array}               the nodes
 */
export function getPageNodes({ edges } = { edges: [] }) {
  if (!edges) {
    return [];
  }

  return edges.map(edge => edge.node);
}
